import characterData from './characters.json';

// 카테고리 설정 (메타데이터)
export const categoryConfig = {
  art: {
    name: '작화',
    wildcardEnabled: false
  },
  pose: {
    name: '포즈',
    wildcardEnabled: true
  },
  character: {
    name: '캐릭터',
    wildcardEnabled: false
  }
};

// 작화 대분류 태그 데이터
export const artTags = {
  그림체1: "1girl, solo, 1.8::artist:kim eb::, 1.65::artist:quasarcake::, 1.6::artist:bm94199 ::, 1.6::artist:torino aqua::, 1.6::artist:yoya yogurt::, 1.3::artist:qiandaiyiyu::, 1.1::artist:dishwasher1910 ::, 1.1::artist:96yottea::, 1.1::artist:freng::, 0.6::artist:cutesexyrobutts::, 0.4::artist:henriiku (ahemaru)::, 0.3::artist:mx2j::, year 2025, year 2024, 2::3d, blender (medium)::, detailed eyes, silky skin, detailed skin texture, ultra detailed, high detail, masterpiece, best quality, very aesthetic, highres, best illustration, novel illustration, -3::simple illustration::, -1::censored::, -3::artist collaboration::, 1.5::medieval fantasy::",
  그림체2: "1girl, 1.5::artist:sasamori tomoe, artist:sohn woohyoung::, 0.9::artist:hero_neisan, artist:takano suzu::, 0.4::artist:kidmo::, 1.3::seoyong ::, 1.2::healthyman ::, freng, 1.1::murata yuusuke ::, 1.2::hiramedousa ::, 1.7::shinjiro, artist:umezawa_itte::, -3::artist collaboration,year 2025, year 2024, realstic 3d, -3::spoken bubble, text, cross-section::, rating:explicit, {{{-3::multiple views}}}, {{{-3::small lines::}}}, 1.5::balanced contrast::, -2::simple illustration::, -1::censored::, best quality, amazing quality, very aesthetic, highres, incredibly absurdres",
  네거티브1: "blank page, logo, watermark, too many watermarks, reference, signature, artist name, dated, artistic error, scan artifacts, jpeg artifacts, upscaled, aliasing, film grain, heavy film grain, dithering, chromatic aberration, digital dissolve, artist:xinzoruo, one-hour drawing challenge, toon (style), 1990s (style), 4koma, 2koma, mutation, deformed, distorted, disfigured, bad anatomy, unnatural hair, bad face, mob face, bad eyes, empty eyes, bad proportions, bad limbs, amputee, bad arm, bad hands, bad hand structure, six fingers extra digits, fewer digits, bad leg, extra leg, distorted composition, bad perspective, disorganized colors, unfinished, incomplete, displeasing, very displeasing, unsatisfactory, inadequate, deficient, subpar, poor, blurry, lowres, worst quality, bad quality, fewer details, bad portrait, bad illustration"
};

// 포즈 대분류 태그 데이터
export const poseTags = {
  "v pose": "v pose",
  "w pose": "w pose",
  "hands on own cheek": "hands on own cheek",
  "licking finger": "licking finger",
  "thumb up": "thumb up",
  "salute": "salute",
  "4-finger heart hands": "4-finger heart hands",
  "finger heart": "finger heart",
  "shushing": "shushing",
  "hand over own mouth": "hand over own mouth",
  "hand on own cheek": "hand on own cheek",
  "chin rest": "chin rest",
  "index finger raised": "index finger raised",
  "finger gun": "finger gun",
  "heart hands": "heart hands"
};

// 캐릭터 태그 데이터 (characters.json에서 동적으로 생성)
export const characterTags = characterData.characters.reduce((acc, char) => {
  acc[char.name] = char.tag;
  return acc;
}, {});

// 캐릭터를 작품별로 그룹화 (한국어 필드 포함)
export const charactersBySeriesMap = characterData.characters.reduce((acc, char) => {
  if (!acc[char.series]) {
    acc[char.series] = [];
  }
  acc[char.series].push({
    name: char.name,
    name_ko: char.name_ko,
    series: char.series,
    series_ko: char.series_ko,
    tag: char.tag,
    id: char.id
  });
  return acc;
}, {});

// 모든 작품명 리스트 (정렬됨)
export const allSeries = Object.keys(charactersBySeriesMap).sort();

